import { render, staticRenderFns } from "./DocumentKeywordsTable.vue?vue&type=template&id=57539149"
import script from "./DocumentKeywordsTable.vue?vue&type=script&lang=js"
export * from "./DocumentKeywordsTable.vue?vue&type=script&lang=js"
import style0 from "./DocumentKeywordsTable.vue?vue&type=style&index=0&id=57539149&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports